import PropTypes from "prop-types";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../style/SearchBar.css";

const SearchBar = ({
  value,
  onChange,
  placeholder = "Search...",
  darkMode,
  size = "medium", // small, medium, large
  fullWidth = false,
  onFocus,
  onBlur,
  autoFocus = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleClear = () => {
    onChange("");
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <div
      className={`search-bar ${
        darkMode ? "dark-mode" : ""
      } search-bar--${size} ${isFocused ? "search-bar--focused" : ""} ${
        fullWidth ? "search-bar--full-width" : ""
      } ${value ? "search-bar--has-value" : ""}`}
    >
      <FontAwesomeIcon icon={faSearch} className="search-bar__icon" />

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="search-bar__input"
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoFocus={autoFocus}
      />

      {value && (
        <button
          className="search-bar__clear"
          onClick={handleClear}
          aria-label="Clear search"
          type="button"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  darkMode: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  fullWidth: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
};

export default SearchBar;

// Usage examples:
//
// 1. Basic search:
// <SearchBar value={search} onChange={setSearch} darkMode={darkMode} />
//
// 2. Full width:
// <SearchBar value={search} onChange={setSearch} darkMode={darkMode} fullWidth />
//
// 3. Small size:
// <SearchBar value={search} onChange={setSearch} darkMode={darkMode} size="small" />
